import { FonteConciliacao } from "@/models/conciliation-config.model";

export const CAMPOS_POR_FONTE_CONCILIACAO: Record<FonteConciliacao, string[]> = {
  proposta_financeira: [
    "id",
    "shortHash",
    "dataCriacaoProposta",
    "valorLiberado",
    "valorParcela",
    "quantidadeParcela",
    "numeroCcb",
    "valorSeguro",
    "valorIof",
    "valorDesconto",
    "processorId",
    "processorName",
    "creditPromoterId",
    "creditPromoterName",
    "corbanId",
    "corbanName",
    "sellerId",
    "sellerName",
    "commercialManagerId",
    "commercialManagerName",
    "insuranceCompanyId",
    "insuranceCompanyName",
    "createdAt",
    "updatedAt",
    "deletedAt",
  ],
  financial_info: [
    "id",
    "employerType",
    "employerDocument",
    "releasedAmount",
    "installmentValue",
    "ipSignedUser",
    "numberOfInstallments",
    "loanAmount",
    "monthlyRate",
    "annualCETAmount",
    "monthlyCETAmount",
    "iofAmount",
    "annualRate",
    "insuranceValue",
    "policyNumber",
    "contractType",
    "contractUrl",
    "signedContractUrl",
    "releaseAmountEnabled",
    "proposalId",
    "contractSplitUrl",
    "signedContractSplitUrl",
    "endorsementReceiptUrl",
    "cancellationReceiptUrl",
    "createdAt",
    "updatedAt",
  ],
  financial_insurance_report: [
    "id",
    "proposal_id",
    "policyPurchaseId",
    "ticket",
    "name",
    "policyPurchaseDate",
    "amount",
    "iof",
    "premiumLiquid",
    "comissionPartnerTwo",
    "comissionGt",
    "ir",
    "liquidValue",
    "status",
    "external_id",
    "contract_number",
    "daily_closing_id",
    "debt_amount",
    "start_date",
    "end_date",
    "corban_comission",
    "wl_agency",
    "wl_user",
    "last_update",
    "instalments",
    "gt",
    "hp",
    "comissionPartnerTwoPartner",
    "financialReportId",
    "createdAt",
    "updatedAt",
  ],
  financial_processor_report: [
    "codigo",
    "dtInclusao",
    "situacao",
    "vlrFinanciado",
    "qtdeParcelas",
    "vlrParcela",
    "vlrTAC",
    "vlrBoleto",
    "vlrSeguro",
    "vlrOutrasDespesas",
    "vlrOutrosServicos",
    "vlrTotalCredito",
    "vlrTotalDivida",
    "vlrDesembolso",
    "vlrIOF",
    "percCETMensal",
    "percCETAnual",
    "percJurosMensal",
    "percJurosAnual",
    "codigoOperacao",
    "tipoContrato",
    "dtPagamento",
    "codigoProposta",
    "numeroCCB",
    "motivoRejeicao",
    "textoRetornoPagamento",
    "autenticacaoBancaria",
    "controleBancario",
    "textoMotivoAnalise",
    "propostaLancamentos",
    "propostaLancamentosCampoID",
    "propostaLancamentosDescricaoCampo",
    "propostaLancamentosVlrTransacao",
    "propostaLancamentosDtPrevPagto",
    "propostaLancamentosDtPagamento",
    "propostaLancamentosSituacao",
    "propostaLancamentosLinhaDigitavel",
    "propostaLancamentosDtVenctoBoleto",
    "propostaLancamentosVlrBoleto",
    "propostaLancamentosCodigoBanco",
    "propostaLancamentosNumeroBanco",
    "propostaLancamentosTipoConta",
    "propostaLancamentosAgencia",
    "propostaLancamentosAgenciaDig",
    "propostaLancamentosConta",
    "propostaLancamentosContaDig",
    "propostaLancamentosDocumentoFederal",
    "propostaLancamentosNomePagamento",
    "propostaLancamentosTextoRetornoPagamento",
    "propostaLancamentosAutenticacaoBancaria",
    "propostaLancamentosControleBancario",
    "propostaLancamentosDescricaoOcorrencia",
    "propostaContaPagamentoCodigoBanco",
    "propostaContaPagamentoTipoConta",
    "propostaContaPagamentoAgencia",
    "propostaContaPagamentoAgenciaDig",
    "propostaContaPagamentoConta",
    "propostaContaPagamentoContaDig",
    "propostaContaPagamentoNumeroBanco",
    "propostaContaPagamentoDocumentoFederalPagamento",
    "propostaContaPagamentoNomePagamento"
  ],
  processor: ["id", "name", "ranking", "tac", "createdAt", "updatedAt"],
  simulacao: [
    "vlrSolicitado",
    "prazo",
    "iof",
    "percIof",
    "vlrTAC",
    "vlrSeguro",
    "vlrTotalFinanciado",
    "percJurosMensal",
    "percJurosAnual",
    "dtContratacao",
    "vlrPMT",
    "percCETMensal",
    "percCETAnual",
    "vlrTotalDivida",
    "vlrParcela"
  ],
  produto_contratado: [
    "id",
    "name",
    "partnerComission",
    "zdcComission",
    "minLimit",
    "maxLimit",
    "installments",
    "maxLoanAmount",
    "marginPercentage",
    "insurancePercentage",
    "rebutPercentage",
    "monthlyRate",
    "enabled",
    "gtComission",
    "idCoverageProduct",
    "insuranceCompanyId",
    "tax",
    "idRiskClassifications",
    "cet",
    "tirCapital",
    "createdAt",
    "updatedAt",
    "color",
  ],
  insurance_info: [
    "id",
    "loanAmount",
    "installment",
    "simulationId",
    "externalId",
    "policyId",
    "contractUrl",
    "signedContractUrl",
    "proposalId",
    "iof",
    "idCoverageProduct",
    "insuranceCompanyId",
    "insuranceAmount",
    "createdAt",
    "updatedAt",
  ],
};
